<template>
	<el-form class="ns-evalute" v-loading="loading" style="border-radius: 13px;
    box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;"   >
		<div class="ns-eva-li" v-for="(item, index) in goodsList" :key="index">
			<!-- ข้อมูลผลิตภัณฑ์ -->
			<div class="ns-eva-good">
				<el-image fit="scale-down" :src="$img(item.sku_image, { size: 'mid' })" @error="imageError(index)" @click="toGoodsDetail(item.sku_id)"></el-image>
				<p class="ns-eva-good-name" :title="item.sku_name" @click="toGoodsDetail(item.sku_id)">{{ item.sku_name }}</p>
				<p>฿{{ item.price }}</p>
			</div>

			<!-- แบบฟอร์มการตรวจสอบ -->
			<div class="ns-eva-form">
				<div class="block" v-if="!isEvaluate">
					<span class="demonstration">คะแนนดาว：</span>
					<el-rate v-model="goodsEvalList[index].scores" @change="setStar(index)"></el-rate>
					<div class="level">
						<i
							class="iconfont"
							:class="
								goodsEvalList[index].explain_type == '1'
									? 'iconhaoping1 ns-text-color'
									: goodsEvalList[index].explain_type == '2'
									? 'iconzhongchaping ns-text-color'
									: goodsEvalList[index].explain_type == '3'
									? 'iconzhongchaping'
									: ''
							"
						></i>
						<span>
							{{
								goodsEvalList[index].explain_type == '1'
									? 'ยอดเยียม'
									: goodsEvalList[index].explain_type == '2'
									? 'ปานกลาง'
									: goodsEvalList[index].explain_type == '3'
									? 'ไม่ค่อยดี'
									: ''
							}}
						</span>
					</div>
				</div>

				<div class="ns-textarea">
					<el-input v-if="!isEvaluate" type="textarea" :rows="5" placeholder="กรุณากรอกความคิดเห็นของคุณที่นี่" v-model="goodsEvalList[index].content" maxlength="200" show-word-limit></el-input>
					<el-input v-else type="textarea" :rows="5" placeholder="โปรดป้อนรีวิวติดตามผลของคุณที่นี่" v-model="goodsEvalList[index].again_content" maxlength="200" show-word-limit></el-input>
				</div>

				<el-upload
					ref="upload"
					:class="{ ishide: hide[index] }"
					:action="uploadActionUrl"
					:data="uploadData"
					list-type="picture-card"
					:on-success="
						(file, fileList) => {
							return handleSuccess(file, fileList, index);
						}
					"
					:on-preview="handlePictureCardPreview"
					:on-remove="
						(file, fileList) => {
							return handleRemove(file, fileList, index);
						}
					"
					:on-exceed="handleExceed"
				>
					<i class="el-icon-plus"></i>
				</el-upload>
				<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
				<span>สูงสุดได้ {{ imgList[index].length ? 6 - imgList[index].length : 6 }} รูป</span>
			</div>
		</div>

		<div class="save-btn-wrap"><el-button @click="save" type="primary">ส่ง</el-button></div>
	</el-form>
</template>

<script>
import { mapGetters } from 'vuex';
import { orderInfo, save, uploadImg } from '@/api/order/order';
import Config from '@/utils/config';

export default {
	name: 'evaluate',
	components: {},
	data: () => {
		return {
			loading: true,
			value1: 5,
			memberName: '',
			memberNeadimg: '',
			orderId: null,
			orderNo: '',
			isAnonymous: 0, //จะเผยแพร่โดยไม่ระบุชื่อหรือไม่  1.เปิด เผย，0.สาธารณะ
			goodsList: [], //รายการคําสั่งซื้อ
			goodsEvalList: [], //รายการรีวิว
			imgList: [],
			isEvaluate: 0, //ตัดสินว่าเป็นการตรวจสอบหลังการตรวจสอบหรือไม่
			flag: false, //ป้องกันการคลิกซ้ํา
			siteName: '', // ชื่อร้าน
			shop_deliverycredit: 5, // คะแนนบริการจัดส่ง
			shop_desccredit: 5, // อธิบายคะแนนที่ตรงกัน
			shop_servicecredit: 5, // คะแนนทัศนคติการบริการ
			uploadActionUrl: Config.baseUrl + '/api/upload/evaluateimg',
			uploadData:{app_type: "pc",app_type_name: "PC"},
			dialogImageUrl: '',
			dialogVisible: false,
			hide: []
		};
	},
	created() {
		this.orderId = this.$route.query.order_id;
		this.getUserInfo();
		if (this.orderId) {
			this.getOrderInfo();
		}
	},
	computed: {
		...mapGetters(['defaultGoodsImage'])
	},
	methods: {
		handleSuccess(file, fileList, index) {
			let arr = this.imgList[index];
			arr = arr.concat(file.data.pic_path);
			this.imgList[index] = [];
			this.$set(this.imgList, index, arr);
			if (this.isEvaluate) {
				this.goodsEvalList[index].again_images = this.imgList[index].toString();
			} else {
				this.goodsEvalList[index].images = this.imgList[index].toString();
			}

			if (this.imgList[index].length >= 6) {
				this.hide[index] = true;
			}
		},
		handleRemove(file, fileList, index) {
			let i = util.inArray(file.response.data.pic_path, this.imgList[index]);
			this.imgList[index].splice(i, 1);

			if (this.isEvaluate) {
				this.goodsEvalList[index].again_images = this.imgList[index].toString();
			} else {
				this.goodsEvalList[index].images = this.imgList[index].toString();
			}

			if (this.imgList[index].length < 6) {
				this.hide[index] = false;
			}
		},
		handleExceed(file, fileList) {
			// จํานวนภาพมากกว่า6
			this.$message.warning('จํานวนสูงสุดของภาพที่อัปโหลดคือ6แผ่น');
		},
		handlePictureCardPreview(file) {
			// คลิกที่ภาพขนาดใหญ่
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		//รับข้อมูลผู้ใช้
		getUserInfo() {
			this.$store
				.dispatch('member/member_detail', {
					refresh: 1
				})
				.then(res => {
					this.memberName = res.data.nickname;
					this.memberNeadimg = res.data.headimg;
				})
				.catch(err => {
					this.$notify.error({title: 'Error',message: err.message});
				});
		},
		//รับข้อมูลคําสั่งซื้อ
		getOrderInfo() {
			//รับข้อมูลคําสั่งซื้อ
			orderInfo({
				order_id: this.orderId
			})
				.then(res => {
					if (res.code == 0) {
						this.isEvaluate = res.data.evaluate_status;
						this.orderNo = res.data.list[0].order_no;
						this.goodsList = res.data.list;
						this.siteName = res.data.list[0].site_name;

						if (this.isEvaluate) {
							for (let i = 0; i < res.data.list.length; i++) {
								let array = [];
								this.imgList.push(array);
								this.hide.push(false);
								this.goodsEvalList.push({
									order_goods_id: res.data.list[i].order_goods_id,
									goods_id: res.data.list[i].goods_id,
									sku_id: res.data.list[i].sku_id,
									again_content: '',
									again_images: '',
									site_id: res.data.list[i].site_id
								});
							}
						} else {
							for (let i = 0; i < res.data.list.length; i++) {
								let array = [];
								this.imgList.push(array);
								this.goodsEvalList.push({
									content: '', // ประเมินเนื้อหา
									images: '', //อาร์เรย์ของรูปภาพ
									scores: 5, // คะแนน
									explain_type: 1, // ประเภทของการตรวจสอบ
									order_goods_id: res.data.list[i].order_goods_id,
									goods_id: res.data.list[i].goods_id,
									sku_id: res.data.list[i].sku_id,
									sku_name: res.data.list[i].sku_name,
									sku_price: res.data.list[i].price,
									sku_image: res.data.list[i].sku_image,
									site_id: res.data.list[i].site_id
								});
							}
						}
					}

					this.loading = false;
				})
				.catch(err => {
					this.$notify.error({title: 'Error',message: err.message});
					this.$router.push('/member/order_list');
					this.loading = false;
				});
		},
		//ฟังการเปลี่ยนแปลงคะแนน
		setStar(index) {
			if (this.goodsEvalList[index].scores >= 4) {
				this.goodsEvalList[index].explain_type = 1;
			} else if (1 < this.goodsEvalList[index].scores && this.goodsEvalList[index].scores < 4) {
				this.goodsEvalList[index].explain_type = 2;
			} else {
				this.goodsEvalList[index].explain_type = 3;
			}
		},
		imageError(index) {
			this.goodsList[index].sku_image = this.defaultGoodsImage;
		},
		/**
		 * ส่ง
		 */
		save() {
			for (let i = 0; i < this.goodsEvalList.length; i++) {
				if (this.isEvaluate) {
					if (!this.goodsEvalList[i].again_content.trim().length) {
						this.$notify({ message: 'การจัดอันดับของผลิตภัณฑ์ไม่สามารถเว้นว่างได้', title: 'คำเตือน',type: 'warning' });
						return;
					}
				} else {
					if (!this.goodsEvalList[i].content.trim().length) {
						this.$notify({ message: 'การจัดอันดับของผลิตภัณฑ์ไม่สามารถเว้นว่างได้', title: 'คำเตือน',type: 'warning' });
						return;
					}
				}
			}

			let goodsEvaluate = JSON.stringify(this.goodsEvalList);
			let data = {
				order_id: this.orderId,
				goods_evaluate: goodsEvaluate,
				isEvaluate: this.isEvaluate
			};
			if (!this.isEvaluate) {
				data.order_no = this.orderNo;
				data.member_name = this.memberName;
				data.member_headimg = this.memberNeadimg;
				data.is_anonymous = this.isAnonymous;
			}

			if (this.flag) return;
			this.flag = true;

			save(data)
				.then(res => {
					if (res.code == 0) {
						this.$notify({
							message: 'ประเมินความสําเร็จ',
							title: 'เรียบร้อยแล้ว',type: 'success',
							duration: 2000,
							onClose: () => {
								this.$router.push({ path: '/member/order_list' });
							}
						});
					} else {
						this.$notify({ message: res.message, title: 'คำเตือน',type: 'warning' });
						this.flag = false;
					}
				})
				.catch(err => {
					this.$notify.error({title: 'Error',message: err.message});
					this.flag = false;
				});
		},
		/**
		 * ข้ามไปยังข้อมูลผลิตภัณฑ์ใน Store
		 */
		toGoodsDetail(id) {
			this.$router.pushToTab('sku-' + id);
		}
	}
};
</script>
<style lang="scss" scoped>
.ns-evalute {
	margin: 20px 0;
	background: #ffffff;
	padding: 30px;
	border-radius: 5px;
	.ns-eva-li {
		display: flex;
		padding: 20px 0;
		border-bottom: 1px solid #eeeeee;

		.ns-eva-good {
			width: 30%;
			text-align: center;
			.el-image {
				width: 125px;
				height: 125px;
				cursor: pointer;
			}
			.ns-eva-good-name {
				width: 250px;
				margin: 0 auto;
				overflow : hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				cursor: pointer;
			}
		}
	}

	.ns-eva-form {
		width: 70%;
		.ns-textarea {
			position: relative;
		}
		.level {
			display: inline-block;
			margin-left: 50px;
			i {
				margin-right: 5px;
				vertical-align: top;
			}
		}
		.el-textarea {
			margin: 10px 0;
		}
	}
	.el-rate {
		display: inline-block;
		vertical-align: middle;
	}
	.ns-eva-public {
		overflow: hidden;
		.ns-eva-wrap {
			width: 70%;
			float: right;
			margin-top: 20px;
			p {
				font-size: 16px;
				font-weight: 600;
			}
		}
	}
	.save-btn-wrap {
		text-align: center;
		margin-top: 20px;
	}

	.el-dialog {
		img {
			width: auto;
			margin: 0 auto;
		}
	}
}
</style>
<style lang="scss">
.ns-evalute {
	.el-upload--picture-card,
	.el-upload-list--picture-card .el-upload-list__item {
		width: 70px;
		height: 70px;
		line-height: 80px;
		position: relative;
	}
	.el-upload-list--picture-card .el-upload-list__item-thumbnail {
		width: 100%;
		height: auto;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}
	.el-upload-list__item.is-success .el-upload-list__item-status-label {
		display: none;
	}
	.ishide .el-upload--picture-card {
		display: none;
	}
	.el-dialog {
		.el-dialog__body {
			text-align: center;
		}
	}
}
</style>
